<template>
  <Teleport defer to="body">
    <div
      aria-label="Notification"
      aria-live="polite"
      role="status"
      :data-open="open"
      :data-error="error"
      class="data-[error=true]:bg-snackbar-red rounded-xxs gap-xs mb-lg right-lg left-lg px-md py-xs fixed -bottom-20 z-100 mx-auto hidden w-fit max-w-[500px] transform items-center bg-gray-800 text-gray-100 transition-discrete duration-300 data-[open=true]:bottom-15 data-[open=true]:flex motion-safe:transition-all data-[open=true]:starting:-bottom-20"
    >
      <div class="line-clamp-2 wrap-anywhere">
        {{ message }}
      </div>

      <AgendaButton
        v-if="action"
        class="snackbar-action flex-none"
        @click="emit('action')"
      >
        {{ action }}
      </AgendaButton>

      <AgendaButton
        v-if="close"
        class="snackbar-close flex-none"
        aria-label="Fermer notification"
        @click="emit('close')"
      >
        <template #icon>
          <Icon name="fa6-solid:xmark" />
        </template>
      </AgendaButton>
    </div>
  </Teleport>
</template>

<script setup>
defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  error: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: "",
  },
  close: {
    type: Boolean,
    default: false,
  },
  action: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(["action", "close"]);
</script>
